import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id B83F1FBD-0D66-4CEE-91FC-640B78AABF4E
 * name home-floor-1
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-1.svg
 * tags
 * - Home Automation 
 */
export const HomeFloor1Icon = createSvgIcon(<><path d="M12,3L2,12H5V20H19V12H22L12,3M10,8H14V18H12V10H10V8Z" /></>, 'HomeFloor1Icon');
export default HomeFloor1Icon